"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var CardGrid = /*#__PURE__*/function (_React$Component) {
  _inherits(CardGrid, _React$Component);
  var _super = _createSuper(CardGrid);
  function CardGrid(props) {
    var _this;
    _classCallCheck(this, CardGrid);
    _this = _super.call(this, props);
    _this.defaultProps = {
      className: "layout",
      // css class for the whole grid
      draggableHandle: '.drag-handle',
      // the css selector for the drag handle
      cols: props.isMobileView ? 1 : 12,
      rowHeight: 30,
      width: 1170,
      // in px
      containerPadding: [0, 0]
    }; // Initialize the cardGrid

    _this.state = {
      layout: _this.createLayoutFromCardIds(_this.props.cardIds)
    }; // ================ This-Binding ================
    // In react, we must bind the value of this to any functions declared in our class in
    // order to have access to the setState() function inside of those functions.

    _this.renderGridItems = _this.renderGridItems.bind(_assertThisInitialized(_this));
    _this.createLayoutFromCardIds = _this.createLayoutFromCardIds.bind(_assertThisInitialized(_this));
    _this.updateLayoutState = _this.updateLayoutState.bind(_assertThisInitialized(_this)); // ==============================================

    return _this;
  }
  /**
   * Build the Layout object that will control react-grid based on an array
   * of cardIds. This can be called at any time, from card-display to update
   * the grid based on cards that were deleted, added, or grouped.
   * @param cardIds
   */

  _createClass(CardGrid, [{
    key: "createLayoutFromCardIds",
    value: function createLayoutFromCardIds(cardIds) {
      var _this2 = this;
      var appendedXValues = [];
      var bottomRow = 0;
      var layout = cardIds.map(function (cardId, index) {
        // Set defaults for laying out the cards
        var cardWidth = 4;
        var cardHeight = 6;
        var defaultHeight = 12;
        var y = Math.ceil(Math.random() * 4) + 1;
        var x = 0;
        var hasExistingLayout = _this2.props.initialLayout; // If we have an existing layout, we'll just append new cards
        // that aren't already identified in the initialLayout object

        if (hasExistingLayout) {
          removeInvalidLayoutItems.call(_this2); // If we find a saved layout item, use it

          var initialLayoutItem = _.find(_this2.props.initialLayout, function (layoutItem) {
            return layoutItem.i === "".concat(cardId);
          });
          if (initialLayoutItem) {
            return initialLayoutItem;
          } else {
            // If we're here, we're appending a new card that hasn't been saved into the DB yet
            // So we need special logic to determine where to place the card:
            // If we've already appended a card within this loop, bottomRow will be set
            // and we'll use it to determine at what height the next card should be set
            if (bottomRow > 0) {
              y = bottomRow;
            } else {
              // Otherwise, y will just equal the bottom-most row
              y = Math.max.apply(Math, _.pluck(_this2.props.initialLayout, 'y'));
              y = y >= 0 ? y : 0;
              bottomRow = y; // Remember this y value for the next card
            } // Get all the X values for the current row.

            var xValues = _.chain(_this2.props.initialLayout).filter(function (el) {
              return el.y === y;
            }).pluck('x').value(); // In order to determine x we need to know 2 things:
            // 1. Is there already a card there within the initialLayout? xValues will tell us.
            // 2. Has a card just been appended to this row but not yet saved? appendedXValues will tell us.
            // If neither source includes a number we'll use that number; searching for left-most position first.

            x = !(xValues.indexOf(0) > -1) && !(appendedXValues.indexOf(0) > -1) ? 0 : !(xValues.indexOf(4) > -1) && !(appendedXValues.indexOf(4) > -1) ? 4 : !(xValues.indexOf(8) > -1) && !(appendedXValues.indexOf(8) > -1) ? 8 : -1;
            var startNewRow = x === -1;
            if (startNewRow) {
              // Increase y by cardHeight
              y += cardHeight; // Save the new y value as the current height so next
              // appended card will be appended at the new height.

              bottomRow = y; // x will be the left-most position (0)

              x = 0; // If we're starting a new row, the first appended X value
              // will be the current card in the left-most position (0)

              appendedXValues = [0];
            } else {
              // If we're not starting a new row, just push the current card position into the list
              // of x values so that the next card will get bumped up from that.
              appendedXValues.push(x);
            }
          }
        } else {
          // If no existing layout, all X/Y layouts will be auto-generated
          x = index * cardWidth % _this2.defaultProps.cols;
          y = Math.floor(index / (cardHeight / 2)) * y;
        }
        return {
          i: "".concat(cardId),
          // Stringify - Very important because i is expected to be a string
          x: x,
          y: y,
          w: cardWidth,
          h: defaultHeight,
          minH: cardHeight,
          minW: cardWidth
        };
      });
      if (!this.props.isMobileView) {
        this.setState({
          layout: layout
        });
      } // We're returning after setting state, so that when this is called
      // from the constructor method, we initialize the correct state. In all other
      // cases, setState() will do the heavy lifting for us.

      return layout;
      function removeInvalidLayoutItems() {
        /**
         * This arcane spell simply finds any IDs that are not valid. It just grabs the difference
         * between what was saved (initialLayout) and what was actually passed to the function (cardIds)
         * and removes any layoutItems that are no longer relevant.
         * This most often will be the result of a deletion or grouping where originally cardA had a
         * layoutItem saved in the DB, but now that it's no longer relevant (deleted, or grouped, etc)
         * we don't need to reference it anymore.
         * This is all so that the logic that determines where newly appended cards should go, can perform correctly.
         */
        var listOfInvalidIds = _.chain(this.props.initialLayout).pluck('i').map(_.partial(parseInt, _, 10)).difference(cardIds).value();
        this.props.initialLayout = _.reject(this.props.initialLayout, function (item) {
          return listOfInvalidIds.indexOf(parseInt(item.i)) > -1;
        });
      }
    }
  }, {
    key: "updateLayoutState",
    value: function updateLayoutState(layout) {
      this.setState({
        layout: layout
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.initializeUpdateSavedLayoutFunction(this.updateLayoutState);
    }
    /**
     * This creates all of the grid elements based on the defined layout.
     * It iterates over each element and matches the {key} attribute to the cardId
     * @returns {*}
     */
  }, {
    key: "renderGridItems",
    value: function renderGridItems() {
      // If we don't have an initial layout, we'll have to create
      // a layout from the cardIds provided
      if (!this.state.layout) {
        this.createLayoutFromCardIds(this.props.cardIds); // Otherwise, we'll just use the existing layout to genereate DOM elements
      } else {
        return this.state.layout.map(function (el) {
          return React.createElement("div", {
            key: el.i
          }, React.createElement("div", {
            "data-card-id": el.i
          }));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ReactGridLayout, _extends({
        layout: this.state.layout
      }, this.props, this.defaultProps), this.renderGridItems());
    }
  }]);
  return CardGrid;
}(React.Component); // Allow the react component to be referenced in the angular HTML

angular.module('wsLrs').value('CardGrid', CardGrid);
